"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/stable");
require("regenerator-runtime/runtime");
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var react_redux_1 = require("react-redux");
var connected_react_router_1 = require("connected-react-router");
var styles_1 = require("@material-ui/core/styles");
var react_localize_redux_1 = require("react-localize-redux");
var date_fns_1 = __importDefault(require("@date-io/date-fns"));
// import enLocale from "date-fns/locale/en-US";
var nb_1 = __importDefault(require("date-fns/locale/nb"));
var pickers_1 = require("@material-ui/pickers");
var core_1 = require("@material-ui/core");
require("./app/style/styles.less");
var theme_1 = __importDefault(require("./app/style/theme"));
var App_1 = __importDefault(require("./app/App"));
var PageSettingStore_1 = require("./app/store/PageSettingStore");
var apiUrls_1 = require("./youwell-common/apiUrls");
var reduxUtils_1 = require("./youwell-common/reduxUtils");
var store_1 = __importStar(require("./app/store"));
var localization_1 = require("./app/localization");
var apiUrl = (_a = document.getElementById('react-app')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-api-url');
var appVersion = (_b = document.getElementById('react-app')) === null || _b === void 0 ? void 0 : _b.getAttribute('data-app-version');
var appConfig = JSON.parse(((_c = document.getElementById('react-app')) === null || _c === void 0 ? void 0 : _c.getAttribute('data-app-config')) || '');
if (!apiUrl) {
    throw new Error('Missing asp-prerender parameter: data-apiUrl');
}
(0, apiUrls_1.setApiRoot)(apiUrl);
PageSettingStore_1.actionCreators.setVersion(appVersion)(store_1.default.dispatch);
PageSettingStore_1.actionCreators.setAppConfig(appConfig)(store_1.default.dispatch);
var localizationInitialization = (0, localization_1.translateInitialization)(appConfig.language);
var MainApp = function () {
    var prefersDarkMode = (0, core_1.useMediaQuery)('(prefers-color-scheme: dark)');
    var theme = React.useMemo(function () { return (0, theme_1.default)(appConfig, prefersDarkMode); }, [prefersDarkMode]);
    return (React.createElement(styles_1.MuiThemeProvider, { theme: theme },
        React.createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1.default, locale: nb_1.default },
            React.createElement(react_localize_redux_1.LocalizeProvider, { store: store_1.default, initialize: localizationInitialization },
                React.createElement(react_redux_1.Provider, { store: store_1.default },
                    React.createElement(connected_react_router_1.ConnectedRouter, { history: store_1.history },
                        React.createElement(App_1.default, null)))))));
};
var renderApp = function () {
    ReactDOM.render(React.createElement(MainApp, null), document.getElementById('react-app'));
};
if (module.hot) {
    module.hot.accept('./app/store', function () {
        (0, reduxUtils_1.updateStore)(store_1.default, store_1.reducers, store_1.history);
    });
}
renderApp();
